import { render } from "./Rainbow.vue?vue&type=template&id=1279bc18"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Rainbow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1279bc18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1279bc18', __exports__)) {
    api.reload('1279bc18', __exports__)
  }
  
  module.hot.accept("./Rainbow.vue?vue&type=template&id=1279bc18", () => {
    api.rerender('1279bc18', render)
  })

}


export default __exports__